import * as React from 'react'
import { Row, Button, Glyphicon } from 'react-bootstrap'
import { match } from 'react-router-dom'
interface ThankYouProps {
	match: match<{ username: string }>
}

function clickHandler() {
	location.href = '/users/login'
}

const ThankYouContainer = (props: ThankYouProps) => {
	const hStyle: React.CSSProperties = {
		textAlign: 'center',
	}
	const email = props.match.params.username
	return (
		<div>
			<Row>&nbsp;</Row>
			<Row>&nbsp;</Row>

			<h4 style={hStyle}>Thank you!</h4>
			<h4 style={hStyle}>
				An email has been sent to <strong>{email}</strong> with a link to follow for setting up a new password.
			</h4>
			<h4 style={hStyle}>Please allow a few minutes and check your email.</h4>

			<Row>&nbsp;</Row>
			<Row>&nbsp;</Row>

			<Button bsStyle="primary" block onClick={clickHandler}>
				Login <Glyphicon glyph="log-in" />
			</Button>

			<Row>&nbsp;</Row>
			<Row>&nbsp;</Row>
		</div>
	)
}

export default ThankYouContainer
